<template>
  <b-row>
    <h4 class="pcg-new-offer-header-text">{{ $t('components.abk_new_offer_step_3_form.info_text') }}</h4>
    <h3 class="header-title col-12 mb-4">
      <i class="pcg-icon-eye mr-3"></i>
      {{ $t('components.abk_new_offer_step_3_form.title') }}
    </h3>
    <b-col cols="12">
      <b-row>
        <abk-content-preview class="col-12 col-xl-8" :attachments="attachments" :content-sections="content" expandable/>
        <abk-quick-info class="col-12 col-xl-4" :offer-info="quickInfo"/>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import AbkContentPreview from './AbkContentPreview'
import AbkQuickInfo from './AbkQuickInfo'
export default {
  name: 'AbkNewOfferStep3Form',
  components: { AbkQuickInfo, AbkContentPreview },
  props: {
    quickInfo: Object,
    content: Array,
    attachments: Array
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/stylesheets/vars";

  .header-title {
    color: $main-color;
    display: inline-block;
    text-transform: uppercase;
    font-weight: bold;
    i {
      font-size: $font-size-m;
    }
  }
</style>

<style lang="scss">
  @import "../assets/stylesheets/vars-contrast";
  .contrast{
    .header-title {
      color: $main-color;
    }
  }
</style>
